import i18next from "../i18n";

export const tags = {
  sectionTitle: i18next.t("tags.sectionTitle"),
  icon: null,
  list: [
    "JavaScript",
    "TypeScript",
    "Python",
    "Ruby",
    "SQL",
    "React.js",
    "Next.js",
    "Vue.js",
    "Node.js",
    "NestJS",
    "Express",
    "MongoDB",
    "PostgreSQL",
    "MySQL",
    "Redis",
    "Styled Components",
    "Sass",
    "Tailwind CSS",
    "Material UI",
    "Jest",
    "React Testing Library",
    "Cypress",
    "Pytest",
    "Docker",
    "Kubernetes",
    "GitHub Actions",
    "AWS",
    "Postman",
    "Figma",
    "Jira",
    "Notion",
    "Miro",
  ],
};

export default tags;
